module.exports = {
  isDev: 1, // 0 for iTrobes, 1 for Everrise
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
}